import React, { ReactNode } from "react";

import "./dropdownItem.scss";

export interface DropdownItemProps {
  postIcon?: ReactNode;
  preIcon?: ReactNode;
  text: string;
  active?: boolean;
}

const DropdownItem: React.FC<DropdownItemProps> = ({
  postIcon = null,
  preIcon = null,
  text,
  active = false,
}) => (
  <div className="dropdown-item2">
    {preIcon}
    <div className="dropdown-item__text typo-body2">{text}</div>
    {!active && postIcon}
  </div>
);

export default DropdownItem;
